<template>
  <v-dialog v-model="dialogShow" persistent width="540">
    <v-card>
      <v-card-title class="tipsDialog-title">
        温馨提示
        <v-spacer></v-spacer>
        <p @click="hideDialog" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text class="tipsDialog-mainAreaNoIcon">
        <p class="tipsDialog-mainAreaNoIcon-text">内容删除后无法恢复，确认删除？</p>
        <div class="tipsDialog-mainArea-btnLine">
          <v-btn @click="hideDialog" width="100" height="35" color="#F5F5F5">取消</v-btn>
          <v-btn @click="deleteCreationOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确认</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteCreationDialog",
  props:["dialogShow"],
  methods:{
    deleteCreationOK(){
      let data = new FormData();
      data.append('infoId',this.$store.state.deleteCreationId);
      this.$axios({
        method:"post",
        url:"/authorApi/main-info/deleteMainInfo",
        data:data
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.$emit("deleteOKFun")
          this.hideDialog();
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //隐藏弹窗
    hideDialog(){
      this.$emit("hideDeleteCreationDialog")
    }


  }
}
</script>

<style scoped>

</style>